import Vue from "vue";
import VueTelInput from "vue-tel-input";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import VueToastr from "vue-toastr";
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);

Vue.use(VueToastr, {});

Vue.use(VueTelInput);
Vue.config.productionTip = false;
Vue.use(Argon);

// i18n
import i18n from './i18n/i18n'

new Vue({
  i18n,
  delimiters: ['${', '}'],
  router,
  render: h => h(App),
  mounted() {
    this.$toastr.defaultPosition = "toast-top-right";
  }
}).$mount("#app");
